import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton, CTA_SUBLABEL } from './CTAButton';
import { MOCKUP_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-900 pb-12 pt-8 sm:pb-16 sm:pt-12" data-id="element-120" data-mp="9lbg511q9bdl">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-72 bg-teal-600/20 blur-3xl" aria-hidden="true" data-id="element-121" data-mp="4na0yr7f9w7e" />
      <div className="relative mx-auto w-full max-w-3xl px-4" data-id="element-122" data-mp="xae7x1q2sklt">
        <div className="flex justify-center" data-id="element-123" data-mp="xb5tdjpyl1yd">
          <span className="rounded-full border border-teal-400/40 bg-teal-500/10 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.22em] text-teal-400" data-id="element-124" data-mp="sb1e1x0sed9q">
            Dr. Karito
          </span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 text-center font-display text-[34px] font-black leading-[1.05] tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-125" data-mp="3d1sc51sntrv8">
          Prescribe GLP-1 safely and{' '}
          <span className="text-teal-400" data-id="element-126" data-mp="3o73q0dt77y94">confidently</span>
        </motion.h1>

        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-white/75 sm:text-lg" data-id="element-127" data-mp="399jmzcfv4d5l">
          The <strong className="font-semibold text-white" data-id="element-128" data-mp="3e7ux7oa2kpoc">GLP-1 Clinical Pathway™</strong> — a
          real, evidence-based protocol from the first consultation to long-term follow-up.
        </p>

        <div className="mt-5 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[12px] font-medium text-white/70 sm:text-sm" data-id="element-129" data-mp="35aaueawk6lbm">
          <span className="flex items-center gap-1.5" data-id="element-130" data-mp="2viy3blil3z6n">
            <StarIcon className="h-4 w-4 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-131" data-mp="2vjg6l23nzdo2" />
            4.9/5 · 1,200+ physicians
          </span>
          <span className="flex items-center gap-1.5" data-id="element-132" data-mp="2lkqw3ue3kvhu">
            <ShieldCheckIcon className="h-4 w-4 text-teal-400" aria-hidden="true" data-id="element-133" data-mp="2lk8wqow5215p" />
            7-day guarantee
          </span>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mt-8" data-id="element-134" data-mp="nbba6qtxtx1l">
          <img src={MOCKUP_IMAGE} alt="GLP-1 Clinical Pathway: 6 clinical volumes and 5 bonuses" className="mx-auto block w-full max-w-2xl drop-shadow-2xl" loading="eager" data-id="element-135" data-mp="ddf5agrlfybx" />
        </motion.div>

        <p className="mt-6 text-center text-[13px] leading-relaxed text-white/70 sm:text-base" data-id="element-136" data-mp="162ccnou9oapw">
          Walk into every consultation with a clear protocol — without guessing, without hesitation,
          and without avoidable mistakes.
        </p>

        <div id="hero-cta" className="mx-auto mt-7 max-w-md" data-id="element-137" data-mp="3ltglflt1eim8">
          <CTAButton label="Get the GLP-1 Clinical Pathway" data-id="element-138" data-mp="3lqug7stmcf76" />
          <p className="mt-3 text-center text-[11px] font-medium leading-relaxed text-white/60 sm:text-xs" data-id="element-139" data-mp="3hqalsx0fjpoq">
            {CTA_SUBLABEL}
          </p>
        </div>
      </div>
    </header>;
}